import { Box, Button, Chip } from '@mui/material';
import { AttachFileOutlined } from '@mui/icons-material';

interface FileUploadProps {
  file: File | null;
  onChange: (file: File | null) => void;
  accept?: string;
  label?: string;
}

const FileUpload = ({
  file,
  onChange,
  accept = '*/*',
  label = 'Attach File (Optional)',
}: FileUploadProps) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      onChange(event.target.files[0]);
    }
  };

  const handleRemove = () => {
    onChange(null);
  };

  return (
    <Box>
      <input
        accept={accept}
        style={{ display: 'none' }}
        id="file-upload-input"
        type="file"
        onChange={handleFileChange}
      />
      <label htmlFor="file-upload-input">
        <Button
          variant="outlined"
          component="span"
          startIcon={<AttachFileOutlined />}
          fullWidth
        >
          {file ? file.name : label}
        </Button>
      </label>
      {file && (
        <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Chip label={file.name} onDelete={handleRemove} size="small" />
        </Box>
      )}
    </Box>
  );
};

export default FileUpload;
